<template>
	<table class="form">
		<thead>
			<tr>
				<th colspan="2"><sym-icon name="case"></sym-icon> Ukázkový formulář</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>Název:</td>
				<td><input type="text" value="ahoj"></td>
			</tr>
			<tr>
				<td>Typ:</td>
				<td>
					<select>
						<option value="good">Dobrý</option>
						<option value="great">Skvělý</option>
						<option value="bad">Špatný</option>
					</select>
				</td>
			</tr>
		</tbody>
		<tbody>
			<tr class="controls">
				<td></td>
				<td style="text-align:right"><button type="button">Odeslat</button></td>
			</tr>
		</tbody>
	</table>
</template>

<script setup lang="ts">
import SymIcon from "@fd/helpers/SymIcon.vue";
const props = defineProps({});
</script>

<style>

</style>